import {
    TEAMPLANS_FETCHING,
    TEAMPLANS_SUCCESS,
    TEAMPLANS_FAILED,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case TEAMPLANS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case TEAMPLANS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case TEAMPLANS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  